import { useState } from 'react';

function WalletRow(props) {
    const [logoError, setLogoError] = useState(false);

    if (!props.symbol || (!parseFloat(props.available) && !parseFloat(props.onOrder))) return <></>;

    function handleImageError() {
        setLogoError(true);
    }

    return (
        <tr>
            <td className="text-gray-900">
                {!logoError && (
                    <img 
                        className="me-2" 
                        width={16} 
                        src={`/img/icons/black/${props.symbol.toLowerCase()}.svg`} 
                        onError={handleImageError}
                        alt={props.symbol}
                    />
                )}
                {props.symbol}
            </td>
            <td className="text-gray-900">
                {`${parseFloat(props.available).toFixed(8)}`.substring(0, 10)}
            </td>
            <td className="text-gray-900">
                {`${parseFloat(props.onOrder).toFixed(8)}`.substring(0, 10)}
            </td>
        </tr>
    )
}

export default WalletRow;